import { useState } from "react";
import { apiPostPut } from "../../api/api_methods";
import { useStores } from "../../store";
import { CiSearch } from "react-icons/ci";
import Loader from "../reusble_components/loader";
import { MdNotifications } from "react-icons/md";
import Tooltip from "../reusble_components/tooltip";

export function FilterJobs({ show, onClose, onApply, onCancle }) {
  const [open, setOpen] = useState(show);

  // Fix: Merge both destructuring into one
  const { UserStore, RecuiterStore, PopupStore } = useStores(); // Corrected line

  const [filters, setFilters] = useState(() => {
    return (
      RecuiterStore.filters || {
        search: "",
        salary: "",
        experience: "",
        location: "",
        workMode: "",
        jobMode: "",
        jobType: "",
      }
    );
  });

  function notify(onClick) {
    PopupStore.setNotification(true);
    if (onClick) {
      onClick();
    }
  }

  const [loader, setLoader] = useState(false);

  const isFiltersEmpty = (filters) => {
    return Object.values(filters).every((value) => value === "");
  };

  const fetchFilteredData = async (filters1 = null) => {
    setLoader(true);
    // Check if filters are empty
    if (filters1) {
      RecuiterStore.setFilter(true);
    } else {
      RecuiterStore.setFilter(false);
    }
    try {
      const response = await apiPostPut(
        filters1,
        `/job-post/job-posts`,
        "POST"
      );
      if (response.status === 200 && response.body.success) {
        RecuiterStore.setJobPosts(response.body.data);
        RecuiterStore.jobpostcount = response?.body?.count;
        console.log(response.body.data);
        setLoader(false);
        onClose();
      } else {
        console.log(`Error fetching job data: ${response.body.message}`);
        setLoader(false);
      }
    } catch (error) {
      console.error("Error fetching job data:", error);
    }
  };

  const handleApply = () => {
    if (
      filters.salary === "" &&
      filters.search === "" &&
      filters.experience === "" &&
      filters.location === "" &&
      filters.workMode === "" &&
      filters.jobMode === "" &&
      filters.jobType === ""
    ) {
      alert("please apply filters");
      return;
    } else {
      fetchFilteredData(filters);
      console.log(filters);
      setOpen(false);
      onClose();
    }
  };

  const handleCLose = () => {
    onClose();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
    console.log(filters);
    setFilters((prevFilters) => {
      const updatedFilters = { ...prevFilters, [name]: value };
      RecuiterStore.filters = updatedFilters; // Store filters globally
      return updatedFilters;
    });
  };

  const handleKeyPress = (event) => {
    if (!isNaN(event.key) && event.key !== " ") {
    } else if (event.key === "Enter") {
      fetchFilteredData(filters);
      setOpen(false);
      onClose();
    }
  };

  return (
    <div className="flex justify-end items-center max-w-full md:w-auto">
      <Loader loader={loader} />
      <div
        onClick={() => notify()}
        className="flex bg-[#f1f1f1] items-center justify-center w-10 h-10 md:w-16 md:h-16 rounded-full cursor-pointer mr-4 md:mr-7"
      >
        <Tooltip
          id="notificationbtntooltip"
          position="bottom"
          content="Notifications"
        >
          <MdNotifications className="w-6 h-6 md:w-8 md:h-8" />
        </Tooltip>
      </div>
      <div
        className="flex relative justify-end items-center w-full md:w-auto py-1 px-4 md:py-3 md:px-6 rounded-lg border-2 border-primary"
        style={{ boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)" }}
      >
        <input
          value={filters.search}
          onChange={handleChange}
          name="search"
          type="text"
          placeholder="Search by name, label..."
          className="placeholder-gray-400 truncate text-sm md:text-md lg:text-lg outline-none w-full md:w-auto"
          onKeyPress={handleKeyPress}
        />
        <CiSearch className="text-xl md:text-2xl lg:text-4xl text-primary absolute right-4 md:right-6" />
      </div>

      {show && (
        <div className="fixed inset-0 z-50 flex items-start justify-end bg-gray-500 bg-opacity-50 backdrop-blur-sm">
          <form
            onSubmit={(e) => e.preventDefault()}
            className="bg-white p-6 text-sm md:text-base rounded shadow-lg w-80 md:w-80 lg:w-96 mx-auto mt-20 md:mt-20"
          >
            <div className="flex flex-col gap-2 ">
              <h2 className="text-base">Filter Jobs</h2>
              <button
                className="text-sm md:text-md hover:underline text-primary w-full flex justify-end"
                type="reset"
                onClick={() => {
                  const defaultFilters = {
                    search: "",
                    salary: "",
                    experience: "",
                    location: "",
                    workMode: "",
                    jobMode: "",
                    jobType: "",
                  };
                  setFilters(defaultFilters);
                  RecuiterStore.filters = defaultFilters; // Reset store filters too
                  fetchFilteredData();
                  setOpen(false);
                  onClose();
                }}
              >
                Reset
              </button>
            </div>

            <div className="grid grid-cols-3 md:grid-cols-3 gap-1">
              <div className="mb-4">
                <label className="block mb-1">Salary</label>
                <input
                  type="number"
                  name="salary"
                  onWheel={(e) => e.target.blur()}
                  value={filters.salary}
                  onChange={handleChange}
                  className="w-full p-2 border rounded"
                  placeholder="100000"
                />
              </div>
              <div className="mb-4">
                <label className="block mb-1">Experience</label>
                <input
                  type="number"
                  name="experience"
                  onWheel={(e) => e.target.blur()}
                  value={filters.experience}
                  onChange={handleChange}
                  placeholder="Experience"
                  className="w-full p-2 border rounded"
                />
              </div>
              <div className="mb-4">
                <label className="block mb-1">Location</label>
                <input
                  type="text"
                  name="location"
                  value={filters.location}
                  onChange={handleChange}
                  className="w-full p-2 border rounded"
                  placeholder="Locations"
                  onKeyPress={handleKeyPress}
                />
              </div>
              <div className="mb-4">
                <label className="block mb-1">Work Mode</label>
                <select
                  name="workMode"
                  value={filters.workMode}
                  onChange={handleChange}
                  className="w-full p-2 border rounded"
                  onKeyPress={handleKeyPress}
                >
                  <option value="">All</option>
                  <option value="workFromHome">Work From Home</option>
                  <option value="workFromOffice">Work From Office</option>
                  <option value="hybrid">Hybrid</option>
                </select>
              </div>
              <div className="mb-4">
                <label className="block mb-1">Job Mode</label>
                <select
                  name="jobMode"
                  value={filters.jobMode}
                  onChange={handleChange}
                  className="w-full p-2 border rounded"
                  onKeyPress={handleKeyPress}
                >
                  <option value="">Select</option>
                  <option value="part-time">Part time</option>
                  <option value="full-time">Full time</option>
                  <option value="freelance">Freelance</option>
                  <option value="remote">Remote</option>
                </select>
              </div>
              <div className="mb-4">
                <label className="block mb-1">Job Type</label>
                <select
                  name="jobType"
                  value={filters.jobType}
                  onChange={handleChange}
                  className="w-full p-2 border rounded"
                  onKeyPress={handleKeyPress}
                >
                  <option value="">Select</option>
                  <option value="internship">Internship</option>
                  <option value="contract">Contract</option>
                  <option value="fulltime">Full time</option>
                </select>
              </div>
            </div>
            <div className="flex justify-end gap-5 mt-5">
              <button
                onClick={handleApply}
                className="bg-primary text-white rounded-lg py-2 px-6"
              >
                Apply
              </button>
              <button
                onClick={() => onCancle()}
                className="bg-red-500 text-white rounded-lg py-2 px-6"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}
